import { Button, Checkbox } from '@ixyberfree/ixybercomponents';
import React, { useState } from 'react';
import { colorText, ContentPopup, MainText } from 'styles';

import { Modal } from '@ixyberfree/ixybercomponents';

interface IPropsDelBlockWindow {
    isButtonLoading: boolean;
    closeCM?: Function;
    delCB?: Function;
    nameBlock: string;
    idBlock: string;
}

export const DelBlockWindow: React.FC<IPropsDelBlockWindow> = ({
    isButtonLoading,
    closeCM,
    delCB,
    nameBlock,
    idBlock
}) => {
    const [deleteAll, setDeleteAll] = useState<boolean>(false);

    return (
        <Modal
            className="modal-window"
            headerLabel="Удаление"
            width="15rem"
            onCloseClick={() => {
                closeCM && closeCM();
            }}>
            <ContentPopup
                style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', gap: '10px' }}
                onClick={(e) => e.stopPropagation()}>
                <MainText size={14} color={colorText.main}>
                    Удалить {nameBlock}?
                </MainText>
                <Checkbox
                    label={'Удалить все'}
                    checked={deleteAll}
                    onChange={() => setDeleteAll((prev: boolean) => !prev)}
                />
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Button
                        text="Удалить"
                        size="small"
                        styleType="filled"
                        isLoading={isButtonLoading}
                        onClick={() => {
                            delCB && delCB(idBlock, deleteAll);
                        }}
                    />
                    <div style={{ width: '1.8em' }}></div>
                    <Button text="Отменить" size="small" styleType="tinted" onClick={() => closeCM && closeCM()} />
                </div>
            </ContentPopup>
        </Modal>
    );
};

interface IPropsDelBlocksWindow {
    closeCM?: Function;
    delCB?: Function;
    idBlocks: string[];
}

export const DelBlocksWindow: React.FC<IPropsDelBlocksWindow> = ({ closeCM, delCB, idBlocks }) => {
    const [text, setText] = React.useState<string>('Удалить элементы?');
    const [deleteAll, setDeleteAll] = useState<boolean>(false);

    return (
        <Modal
            className="modal-window"
            headerLabel="Удаление"
            width="15rem"
            onCloseClick={() => {
                closeCM && closeCM();
            }}>
            <ContentPopup
                style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', gap: '10px' }}
                onClick={(e) => e.stopPropagation()}>
                <MainText size={14} color={colorText.main}>
                    {text}
                </MainText>
                <Checkbox
                    label={'Удалить все'}
                    checked={deleteAll}
                    onChange={() => setDeleteAll((prev: boolean) => !prev)}
                />
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    {text == 'Удалить элементы?' ? (
                        <Button
                            text="Удалить"
                            size="small"
                            styleType="filled"
                            onClick={() => {
                                setText('Идет удаление....');
                                delCB?.(idBlocks, deleteAll);
                            }}
                        />
                    ) : null}
                    <div style={{ width: '1.8em' }}></div>
                    <Button
                        text="Отменить"
                        size="small"
                        styleType="tinted"
                        onClick={() => {
                            closeCM?.();
                        }}
                    />
                </div>
            </ContentPopup>
        </Modal>
    );
};
